export const PageDataState = {
    Searchs: {
        // enterprise_id: {
        //     type: 'select',
        //     id: 'enterprise_id',
        //     label: 'ผู้ประกอบการ',
        //     value: '',
        //     placeholder: 'ผู้ประกอบการ',
        // },
        // target_group: {
        //     type: 'text',
        //     id: 'target_group',
        //     label: 'กลุ่มเป้าหมาย',
        //     value: '',
        //     placeholder: 'กลุ่มเป้าหมาย',
        // },
        academy_id: {
            type: 'text',
            id: 'academy_id',
            label: 'สถานศึกษา',
            value: '',
            placeholder: 'สถานศึกศา',
        },
        target_industries_id: {
            type: 'select',
            id: 'target_industries_id',
            label: 'อุตสาหกรรม',
            value: '',
            placeholder: 'อุตสาหกรรม',
        },
        position_id: {
            type: 'text',
            id: 'position_id',
            label: 'ตำแหน่ง',
            value: '',
            placeholder: 'ชื่อตำแหน่ง',
        },
        demand_edu_level_id: {
            type: 'text',
            id: 'demand_edu_level_id',
            label: 'ระดับการศึกษา',
            value: '',
            placeholder: 'ระดับการศึกษา',
        },
        // demand_skill_id: {
        //     type: 'select',
        //     id: 'demand_skill_id',
        //     label: 'Skills set',
        //     value: '',
        //     placeholder: 'Skills set',
        // },
        demand_skill_type_id: {
            type: 'select',
            id: 'demand_skill_type_id',
            label: 'ประเภท Skills set',
            value: '',
            placeholder: 'ประเภท Skills set',
        },
        supply_exceeds_demand_flag: {
            type: 'select',
            id: 'supply_exceeds_demand_flag',
            label: 'เงื่อขไขการแสดง',
            value: '1',
            placeholder: 'เงื่อขไขการแสดง',
        },
             
        // status: {
        //     type: 'select',
        //     id: 'status',
        //     label: 'สถานะหลักสูตร',
        //     value: '',
        // },                  
    },
    Inputs: {},
    ReadOnlys: {},
    InputGroup: {},
    Approved: false,
}        